require("normalize.css/normalize.css");
require("styles/App.scss");

import React from "react";
import PubSub from "pubsub-js";

import Header from "./Header";
import VideoWrapper from "./VideoWrapper";

import Pwa from "./ui/Pwa";
import Icons from "./ui/Icons";

// const endPoint = 'https://skate-tv-backend.herokuapp.com/api/get'
const endPoint =
    process.env.API ||
    "https://skate-tv-backend-bjpfl76oyq-od.a.run.app/api/get";

class AppComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            className: "loading",
            videoIndex: 0,
            data: [],
            playing: true,
            status: "init",
        };

        // this._next = this._next.bind(this)
    }

    componentDidMount() {
        this._preloadLoaders();
        this._fetchContent();

        PubSub.subscribe("PREV", this._prev);
        PubSub.subscribe("NEXT", this._next);
        PubSub.subscribe("SHUFFLE", this._shuffle);

        PubSub.subscribe("PLAYING", (e, d) => {
            this.setState({ playing: d.playing });
        });

        PubSub.subscribe("START", () => {
            console.log("START");
            this.setState({
                className: "",
                status: "",
            });
        });
        // PubSub.subscribe("READY", (duration) => {
        //   this.setState({
        //     status: '',
        //     duration: duration
        //   })
        // })
    }

    _preloadLoaders() {
        const list = new Array(12).fill(0).map((v, i) => i);
        list.forEach((el) => {
            // console.log(el)
            const image = new Image();
            // image.src = "../static/noise-" + el + ".gif";
            image.src = "../images/noise-" + el + ".gif";
        });
    }

    _fetchContent() {
        console.log("_fetchContent", endPoint);
        this.setState({ status: "fetching data ..." });

        fetch(endPoint, {
            method: "GET",
            // mode: 'no-cors'
            //headers: {'Content-Type': 'application/json'}
        })
            .then((response) => response.json())
            .then((responseJson) => {
                console.log(responseJson);
                const unique = [...new Set(responseJson)];
                // console.log(unique)

                this.setState({
                    data: unique,
                    videosLength: unique.length,
                });
                this.setState({ status: "fetch data ok :)" });
            })
            .catch((error) => {
                this.setState({ status: JSON.stringify(error) });
                console.error(error);
            });
    }

    _shuffle = () => {
        const { data } = this.state;
        const shuffled = data.sort((a, b) => 0.5 - Math.random());
        console.log(data[0]);
        console.log(shuffled[0]);
        this.setState({
            data: shuffled,
        });
    };

    _prev = () => {
        const { videoIndex, videosLength } = this.state;
        const newIndex = videoIndex > 0 ? videoIndex - 1 : videosLength;

        this.setState({
            className: "loading",
            videoIndex: newIndex,
            progress: null,
        });
    };
    _next = () => {
        const { videoIndex, videosLength } = this.state;

        const newIndex = videoIndex + 1 < videosLength ? videoIndex + 1 : 0;
        console.log("next", newIndex);
        this.setState({
            className: "loading",
            videoIndex: newIndex,
            progress: null,
        });
    };

    render() {
        const {
            status,
            videoIndex,
            data,
            videosLength,
            className,
            muted,
            playing,
            progress,
            duration,
        } = this.state;
        // if(data.length === 0)return (null)
        // console.log(videoIndex +"/"+ videosLength)
        // console.table(data[videoIndex])
        const loader =
            className === "loading" || "is-paused"
                ? "../images/noise-" + Math.round(Math.random() * 11) + ".gif"
                : "../images/noise-2.gif";
        // console.log("status",status)
        return (
            <main
                className={
                    "index " +
                    className +
                    " " +
                    (playing ? "is-playing" : "is-paused")
                }
            >
                {data.length && (
                    <VideoWrapper
                        data={data[videoIndex]}
                        nextVideo={
                            data[videoIndex + 1] ? data[videoIndex + 1] : null
                        }
                    />
                )}

                <div className="gradient"></div>
                <div
                    id="loader"
                    style={{
                        backgroundImage: "url(" + loader + ")",
                    }}
                ></div>

                {status != "" && <div id="status">{"status: " + status}</div>}

                {data.length && (
                    <Header
                        video={data[videoIndex]}
                        index={videoIndex}
                        length={videosLength}
                    />
                )}

                <Pwa />
            </main>
        );
    }
}

AppComponent.defaultProps = {};

export default AppComponent;



// WEBPACK FOOTER //
// ./src/components/App.jsx